// ======================================================================
// 📁 File: src/modules/ppe/components/worker/WorkerKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Worker Master
//   - Total workers
//   - Active workers
//   - Inactive workers
//   - Draft workers
// ======================================================================

import React from "react";

export default function WorkerKpiBar({ rows = [] }) {
  const total = rows.length;

  const active = rows.filter(
    (r) => r.status_code === "ACTIVE"
  ).length;

  const inactive = rows.filter(
    (r) => r.status_code === "INACTIVE"
  ).length;

  const draft = rows.filter(
    (r) => r.status_code === "DRAFT"
  ).length;

  const Card = ({ title, value, color }) => (
    <div
      style={{
        flex: 1,
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        display: "flex",
        alignItems: "center",
        gap: 12,
        boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
        borderLeft: `5px solid ${color}`,
      }}
    >
      <div>
        <div style={{ fontSize: 13, color: "#64748b" }}>
          {title}
        </div>
        <div
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: "#0f172a",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <Card
        title="Total Workers"
        value={total}
        color="#6366f1"
      />

      <Card
        title="Active Workers"
        value={active}
        color="#16a34a"
      />

      <Card
        title="Inactive Workers"
        value={inactive}
        color="#64748b"
      />

      <Card
        title="Draft Workers"
        value={draft}
        color="#f59e0b"
      />
    </div>
  );
}
